<div class="flex flex-col space-y-4">
  <!-- The person -->
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
    <div>
      <input type="text" [ngModel]="firstName()" (ngModelChange)="firstName.set($event)" [maxLength]="nameMaxLength"
        [placeholder]="'hotline.longTerm.firstName' | translate"
        [ngClass]="firstNameError() ? 'border-red-400' : 'border-slate-200'"
        class="w-full border rounded-lg py-1.5 px-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500" />
      @if (firstNameError(); as err) {
        <p class="text-xs text-red-600 mt-1">{{ err.key | translate: err.params }}</p>
      }
    </div>
    <div>
      <input type="text" [ngModel]="lastName()" (ngModelChange)="lastName.set($event)" [maxLength]="nameMaxLength"
        [placeholder]="'hotline.longTerm.lastName' | translate"
        [ngClass]="lastNameError() ? 'border-red-400' : 'border-slate-200'"
        class="w-full border rounded-lg py-1.5 px-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500" />
      @if (lastNameError(); as err) {
        <p class="text-xs text-red-600 mt-1">{{ err.key | translate: err.params }}</p>
      }
    </div>
  </div>
  <div>
    <input type="text" [ngModel]="company()" (ngModelChange)="company.set($event)" [maxLength]="rightNameMaxLength"
      [placeholder]="'hotline.longTerm.company' | translate"
      [ngClass]="companyError() ? 'border-red-400' : 'border-slate-200'"
      class="w-full border rounded-lg py-1.5 px-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500" />
    @if (companyError(); as err) {
      <p class="text-xs text-red-600 mt-1">{{ err.key | translate: err.params }}</p>
    }
  </div>
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
    <div>
      <input type="email" [ngModel]="email()" (ngModelChange)="email.set($event)" autocomplete="off" [maxLength]="emailMaxLength"
        [placeholder]="'hotline.longTerm.email' | translate"
        [ngClass]="emailError() ? 'border-red-400' : 'border-slate-200'"
        class="w-full border rounded-lg py-1.5 px-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500" />
      @if (emailError(); as err) {
        <p class="text-xs text-red-600 mt-1">{{ err.key | translate: err.params }}</p>
      }
    </div>
    <div>
      <input type="tel" [ngModel]="phone()" (ngModelChange)="phone.set($event)" [maxLength]="phoneMaxLength"
        [placeholder]="'hotline.longTerm.phone' | translate"
        [ngClass]="phoneError() ? 'border-red-400' : 'border-slate-200'"
        class="w-full border rounded-lg py-1.5 px-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500" />
      @if (phoneError(); as err) {
        <p class="text-xs text-red-600 mt-1">{{ err.key | translate: err.params }}</p>
      }
    </div>
  </div>

  <!-- Plates -->
  <div>
    <label class="text-xs font-medium text-slate-500 mb-1 block">{{ 'hotline.edit.plates' | translate }}</label>
    <div class="space-y-2">
      @for (plate of plates(); track $index) {
        <div>
          <div class="flex items-center gap-2">
            <input type="text" [value]="plate" (input)="onPlateInput($index, $event)" [maxLength]="maxPlateLength"
              autocomplete="off" spellcheck="false" [placeholder]="'hotline.edit.platePlaceholder' | translate"
              [ngClass]="plateErrors()[$index] ? 'border-red-400' : 'border-slate-200'"
              class="flex-1 border rounded-lg py-1.5 px-2 text-sm font-mono uppercase bg-white placeholder:normal-case placeholder:font-sans focus:outline-none focus:ring-2 focus:ring-blue-500" />
            @if (plates().length > 1) {
              <button type="button" (click)="removePlate($index)" [title]="'hotline.edit.removePlate' | translate"
                class="shrink-0 text-slate-400 hover:text-red-600 transition flex items-center">
                <mat-icon class="text-lg">delete_outline</mat-icon>
              </button>
            }
          </div>
          @if (plateErrors()[$index]; as err) {
            <p class="text-xs text-red-600 mt-1">{{ err.key | translate: err.params }}</p>
          }
        </div>
      }
    </div>
    @if (platesError(); as err) {
      <p class="text-xs text-red-600 mt-1">{{ err.key | translate: err.params }}</p>
    }
    @if (!atPlateLimit()) {
      <button type="button" (click)="addPlate()"
        class="mt-1.5 inline-flex items-center gap-1 text-xs font-medium text-blue-600 hover:text-blue-700">
        <mat-icon class="text-base">add</mat-icon> {{ 'hotline.edit.addPlate' | translate }}
      </button>
    }
  </div>

  <!-- Contract period -->
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
    <div>
      <label class="text-xs font-medium text-slate-500 mb-1 block" for="longTermValidFrom">
        {{ 'hotline.longTerm.validFrom' | translate }}
      </label>
      <app-date-field inputId="longTermValidFrom" [(value)]="validFrom" />
    </div>
    <div>
      <label class="text-xs font-medium text-slate-500 mb-1 block" for="longTermValidTo">
        {{ 'hotline.edit.validTo' | translate }} *
      </label>
      <app-date-field inputId="longTermValidTo" [min]="today" [(value)]="validTo" [invalid]="!!validToError()" />
      @if (validToError(); as err) {
        <p class="text-xs text-red-600 mt-1">{{ err.key | translate: err.params }}</p>
      }
    </div>
  </div>

  <!-- Comment -->
  <input type="text" [ngModel]="comment()" (ngModelChange)="comment.set($event)"
    [placeholder]="'hotline.edit.comment' | translate"
    class="w-full border border-slate-200 rounded-lg py-1.5 px-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500" />

  <button type="button" (click)="submit()" [disabled]="isSubmitting() || !parkingSpaceId()"
    class="bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-white text-sm font-medium py-2 rounded-lg flex items-center justify-center gap-2 transition">
    @if (isSubmitting()) {
      <mat-spinner diameter="18"></mat-spinner>
    } @else {
      <mat-icon class="text-lg">how_to_reg</mat-icon> {{ 'hotline.longTerm.submit' | translate }}
    }
  </button>
</div>
